import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectSettingsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
ProjectSettingsViewTopBar.displayName = "ProjectSettingsViewTopBar"
